import { render, staticRenderFns } from "./ThemeChanger.vue?vue&type=template&id=0ed67933&scoped=true&"
import script from "./ThemeChanger.vue?vue&type=script&lang=js&"
export * from "./ThemeChanger.vue?vue&type=script&lang=js&"
import style0 from "./ThemeChanger.vue?vue&type=style&index=0&id=0ed67933&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed67933",
  null
  
)

export default component.exports